import CloseIcon from 'assets/images/actions/closeIcon.svg?react';
import { AnimatePresence, motion } from 'framer-motion';
import { useDispatch, useSelector } from 'react-redux';
import Backdrop from 'shared/components/Modal/component/backdrop';
import { State } from 'shared/interface';
import { modalClose, setModalContent } from 'shared/store/modal.action';
import './styles.scss';

const Modal: React.FC = () => {
	const isModalOpen = useSelector((state: State) => state.modal.isModalOpen);
	const children = useSelector((state: State) => state.modal.children);
	const settings = useSelector((state: State) => state.modal.settings);
	const { onClose, modalClass } = settings ?? {};

	const dispatch = useDispatch();
	const handleClose = () => {
		dispatch(modalClose(!isModalOpen));
		dispatch(setModalContent(<></>));

		if (onClose) {
			onClose();
		}
	};

	const fadeIn = {
		hidden: {
			opacity: 0,
		},
		visible: {
			opacity: 1,
		},
		exit: {
			opacity: 0,
		},
	};

	return (
		<AnimatePresence exitBeforeEnter initial={false}>
			{isModalOpen && (
				<Backdrop onClick={handleClose}>
					<motion.div
						onClick={(e) => e.stopPropagation()}
						variants={fadeIn}
						initial="hidden"
						animate="visible"
						exit="exit"
						className={'modal ' + (modalClass ? modalClass : '')}
					>
						<button className="modal__close" onClick={handleClose}>
							<CloseIcon />
						</button>
						<div className="modal__content">{children}</div>
					</motion.div>
				</Backdrop>
			)}
		</AnimatePresence>
	);
};

export default Modal;
